const ALLOWED_TYPES = [
  // Video MIME types
  'video/mp4',
  'video/x-m4v',
  'video/quicktime', // .mov
  'video/x-msvideo', // .avi
  'video/webm',
  'video/x-matroska', // .mkv
  'video/matroska', // .mkv (alternative)
  'video/x-flv',
  'video/mp2t', // .ts, .mts, .m2ts
  'video/MP2T', // .ts, .mts, .m2ts (alternative casing)
  'video/vnd.dlna.mpeg-tts', // .mts
  'video/3gpp',
  'video/x-ms-wmv',
  'video/x-ms-asf',
  'video/x-ms-vob', // .vob
  'video/vnd.vob', // .vob (alternative)
  'video/dvd', // .vob (alternative)
  'video/ogg',
  'video/x-realvideo', // .rm, .rmvb
  'video/mpeg',
  'video/x-f4v', // .f4v
  'model/vnd.mts', // .mts (some systems report this)

  // Audio MIME types
  'audio/mpeg', // .mp3
  'audio/mp4',
  'audio/aac',
  'audio/x-aac', // .aac (alternative)
  'audio/wav',
  'audio/ogg',
  'audio/opus',
  'audio/flac',
  'audio/x-flac', // .flac (alternative)
  'audio/aiff',
  'audio/x-aiff', // .aiff (alternative)
  'audio/x-ms-wma',
  'audio/webm', // .webma
  'audio/x-matroska', // .mka
  'audio/x-m4a',
  'audio/x-m4b',
  'audio/ac3',
  'audio/eac3',
  'audio/wavpack', // .wv
  'audio/amr', // .amr
  'application/mxf', // .mxf
  'audio/dsf', // .dsf (DSD)
  'audio/dff', // .dff (DSD)

  // File extensions (for types that might not be recognized by MIME)
  '.mp4',
  '.m4v',
  '.mov',
  '.avi',
  '.webm',
  '.mkv',
  '.flv',
  '.ts',
  '.mts',
  '.m2ts',
  '.3gp',
  '.3gpp',
  '.wmv',
  '.asf',
  '.vob',
  '.ogv',
  '.rm',
  '.rmvb',
  '.mpg',
  '.mpeg',
  '.m2v',
  '.f4v',
  '.mp3',
  '.m4a',
  '.mp4a',
  '.aac',
  '.wav',
  '.ogg',
  '.opus',
  '.flac',
  '.aiff',
  '.wma',
  '.webma',
  '.mka',
  '.m4b',
  '.ac3',
  '.eac3',
  '.wv',
  '.amr',
  '.mxf',
  '.dsf',
  '.dff',

  // Empty string for unrecognized types (e.g., mkv on Mac)
  '',
];

export default ALLOWED_TYPES;
